import initialState from 'reducers/initialState'

import DeleteTrapConfirm from 'components/molecules/DeleteTrapConfirm'
import DeleteGroupConfirm from 'components/molecules/DeleteGroupConfirm'
import DeleteAdminConfirm from 'components/molecules/DeleteAdminConfirm'
import DeleteAdminBlocked from 'components/molecules/DeleteAdminBlocked'
import DeletePeopleConfirm from 'components/molecules/DeletePeopleConfirm'

import EditTrapForm from 'components/organisms/EditTrapForm'
import EditGroupForm from 'components/organisms/EditGroupForm'
import ExportDataForm from 'components/organisms/ExportDataForm'
import CreateGroupForm from 'components/organisms/CreateGroupForm'
import InviteAdminForm from 'components/organisms/InviteAdminForm'
import InviteCodePopover from 'components/organisms/InviteCodePopover'
import TrapDetailsPopover from 'components/organisms/TrapDetailsPopover'
import AssignTrapsPopover from 'components/organisms/AssignTrapsPopover'
import AssignGroupsPopover from 'components/organisms/AssignGroupsPopover'
import OrganisationCodeForm from 'components/organisms/OrganisationCodeForm'
import TransferTrapsPopover from 'components/organisms/TransferTrapsPopover'
import ShareTrapIndividualPopover from 'components/organisms/ShareTrapIndividualPopover'

import { API_CREATE_GROUP_SUCCESS } from 'modules/group'
import { API_CREATE_ORGANISATION_CODE_SUCCESS } from 'modules/organisation'

// Actions 
export const SHOW_POPOVER = 'SHOW_POPOVER'
export const HIDE_POPOVER = 'HIDE_POPOVER'

export const EDIT_TRAP = ['EDIT_TRAP', EditTrapForm]
export const EDIT_GROUP = ['EDIT_GROUP', EditGroupForm]
export const EXPORT_DATA = ['EXPORT_DATA', ExportDataForm]
export const INVITE_ADMIN = ['INVITE_ADMIN', InviteAdminForm]
export const CREATE_GROUP = ['CREATE_GROUP', CreateGroupForm]
export const TRAP_DETAILS = ['TRAP_DETAILS', TrapDetailsPopover]
export const SHOW_INVITE_CODE = ['SHOW_INVITE_CODE', InviteCodePopover]
export const GENERATE_ORG_CODE = ['GENERATE_ORG_CODE', OrganisationCodeForm]
export const DELETE_TRAP_CONFIRM = ['DELETE_TRAP_CONFIRM', DeleteTrapConfirm]
export const ASSIGN_TRAPS_GROUPS = ['ASSIGN_TRAPS_GROUPS', AssignTrapsPopover]
export const DELETE_GROUP_CONFIRM = ['DELETE_GROUP_CONFIRM', DeleteGroupConfirm]
export const DELETE_ADMIN_CONFIRM = ['DELETE_ADMIN_CONFIRM', DeleteAdminConfirm]
export const DELETE_ADMIN_BLOCKED = ['DELETE_ADMIN_BLOCKED', DeleteAdminBlocked]
export const PEOPLE_ASSIGN_GROUPS = ['PEOPLE_ASSIGN_GROUPS', AssignGroupsPopover]
export const DELETE_PEOPLE_CONFIRM = ['DELETE_PEOPLE_CONFIRM', DeletePeopleConfirm]
export const TRANSFER_TRAPS_PROJECT = ['TRANSFER_TRAPS_PROJECT', TransferTrapsPopover]
export const SHARE_TRAP_INDIVIDUAL = ['SHARE_TRAP_INDIVIDUAL', ShareTrapIndividualPopover]

export default function reducer(state = initialState.popover, action) {
  switch (action.type) {
    case SHOW_POPOVER:
      return {
        ...state,
        open: true,
        componentName: action.componentName,
        data: action.data,
      }
    case API_CREATE_ORGANISATION_CODE_SUCCESS:
      return {
        ...state,
        open: true,
        componentName: SHOW_INVITE_CODE[0],
      }
    case API_CREATE_GROUP_SUCCESS:
    case HIDE_POPOVER:
      return {
        ...state,
        open: false,
      }
    default:
      return state
  }
}

// Action Creators 
export function showPopover(popover, data) {
  return {
    type: SHOW_POPOVER,
    componentName: popover[0],
    data,
  }
}

export function hidePopover() {
  return {
    type: HIDE_POPOVER,
  }
}



// WEBPACK FOOTER //
// ./src/modules/popover.js